import React from 'react';
import { Box, IconButton, TableCell, TableRow } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import {
  getPersonalDataMuiHeaderCellSx,
  getPersonalDataMuiSortableHeaderSx,
  personalDataMuiHeaderContentSx,
} from '../styles.ts';
import { TPersonalDataMuiColumn } from '../types.ts';

interface IPersonalDataHeaderRowProps<TRecord extends object> {
  columns: TPersonalDataMuiColumn<TRecord>[];
  sortedField?: string;
  sortedOrder?: 'ascend' | 'descend';
  filters: Record<string, string[]>;
  onSort: (column: TPersonalDataMuiColumn<TRecord>) => void;
  onFilterOpen: (
    event: React.MouseEvent<HTMLElement>,
    column: TPersonalDataMuiColumn<TRecord>
  ) => void;
}

export const PersonalDataMuiTableHeaderRow = <TRecord extends object>({
  columns,
  sortedField,
  sortedOrder,
  filters,
  onSort,
  onFilterOpen,
}: IPersonalDataHeaderRowProps<TRecord>) => (
  <TableRow>
    {columns.map((column) => {
      const isSorted = sortedField === column.dataIndex;
      const hasFilter = Boolean(column.filterDropdown);
      const hasSorter = Boolean(column.sorter);
      const isFiltered = Boolean(filters[column.dataIndex]?.length);

      return (
        <TableCell
          key={column.key}
          align={column.align || 'left'}
          sx={getPersonalDataMuiHeaderCellSx(column.width)}
        >
          <Box sx={personalDataMuiHeaderContentSx}>
            <Box onClick={() => onSort(column)} sx={getPersonalDataMuiSortableHeaderSx(hasSorter)}>
              <span>{column.title}</span>
              {hasSorter &&
                (isSorted ? (
                  sortedOrder === 'ascend' ? (
                    <ArrowUpwardIcon fontSize="small" />
                  ) : (
                    <ArrowDownwardIcon fontSize="small" />
                  )
                ) : (
                  <UnfoldMoreIcon fontSize="small" />
                ))}
            </Box>

            {hasFilter && (
              <IconButton
                size="small"
                onClick={(e) => onFilterOpen(e, column)}
                color={isFiltered ? 'primary' : 'default'}
              >
                <FilterListIcon fontSize="small" />
              </IconButton>
            )}
          </Box>
        </TableCell>
      );
    })}
  </TableRow>
);
